const getFormattedDate = (date) => {
  const currentDate = new Date().toDateString().split(' ').splice(-3);
  const copyMonth = `${currentDate.splice(0, 1)},`;
  return date ? [copyMonth].concat(currentDate).join(' ') : null;
};
export default getFormattedDate;
